import React, { CSSProperties } from 'react';

type Props = {
  children?: React.ReactNode;
  hidden?: boolean;
  loading: boolean;
  style?: CSSProperties;
  circularLoading?: boolean;
};

const Loading: React.FC<Props> = props => {
  const baseStyle = {
    alignItems: 'center',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    width: '100%',
  };
  const style = Object.assign({}, baseStyle, props.style);
  const hidden = props.hidden || false;

  return (
    <>
      {(!props.loading || !hidden) && <>{props.children}</>}
      {props.loading && (
        <div
          style={{
            position: 'relative',
          }}>
          <div style={style}>
            {props.circularLoading ? (
              <img
                src="/static/images/loading/spin-gray.svg"
                alt=""
                style={{
                  height: '50px',
                  width: '50px',
                }}
              />
            ) : (
              <img
                src="/static/images/loading/loading.svg"
                alt=""
                style={{
                  height: '100px',
                  width: '100px',
                }}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Loading;
